import ShowGasBrandMerchant from "./showGasBrandMerchant.js";
import { EditGasBrandMerchantFuel } from "./editGasBrandMerchant.js";
import CreateGasBrandMerchant from "./createGasBrandMerchant.js";

export default {
  ShowGasBrandMerchant,
  EditGasBrandMerchantFuel,
  CreateGasBrandMerchant,
};
